import { Select } from "@normasteaching/norma-ui";

type Props = {
  value?: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
};
export function BooleanInput({ value, onChange, disabled }: Props) {
  return (
    <Select<"true" | "false">
      disabled={disabled}
      value={value ? "true" : "false"}
      options={[
        {
          name: "Sì",
          id: "true",
        },
        {
          name: "No",
          id: "false",
        },
      ]}
      onChange={(v) => {
        onChange(v === "true");
      }}
    />
  );
}
